<div class="container-vehicle">
    <div class="container-vehicle__avatar">
        <!-- <img src="https://cdn-icons-png.flaticon.com/512/147/147144.png" alt=""> -->
        <i class="pi pi-image"></i>
    </div>
    <div class="container-vehicle__details">
        <span class="container-vehicle__details__name">
            {{driver?.FN}} {{driver?.LN}}
        </span>
        <div class="container-vehicle__details__card">
            <span class="container-vehicle__details__card__value">
                {{'vehicle-details-tacho-tab.card'|translate}} {{ _slotData?.Card }}
            </span>
            <button (click)="copyCardNumber()" class="container-vehicle__details__card__copy">
                <i class="pi pi-copy"></i>
            </button>
        </div>
    </div>
</div>
